const RANKING_ITEMS = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，疑似新恋情曝光', heat: '🔥 286.5万', tag: '明星八卦', trend: 'up' },
  { rank: 2, title: '千万粉丝网红直播带货翻车，产品被曝虚假宣传', heat: '🔥 241.8万', tag: '网红翻车', trend: 'up' },
  { rank: 3, title: '热门综艺被曝剧本造假，选手淘汰早有安排', heat: '💥 198.3万', tag: '综艺内幕', trend: 'up' },
  { rank: 4, title: '知名主播涉嫌赌博被平台永久封禁', heat: '📈 165.2万', tag: '直播塌房', trend: 'new' },
  { rank: 5, title: '娱乐圈某制片人深夜发文揭露行业潜规则', heat: '📈 132.7万', tag: '深度揭秘', trend: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            实时榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            吃瓜热榜
          </h2>
          <p className="text-sm text-foreground-500 mt-3">全网热度实时追踪，每小时更新</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {RANKING_ITEMS.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-400'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.heat}</span>
                  {item.trend === 'new' && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">NEW</span>
                  )}
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-400 transition-colors flex-shrink-0 text-lg"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}